export interface PartnerInfo {
  kundennummer?: string;
  name?: string;
  ansprechpartner?: string;
  email?: string;
  telefon?: string;
  adresse?: string;
  website?: string;
  logo?: string;
}

export function hasPartnerContact(info: PartnerInfo): boolean {
  return Boolean(
    info.name || info.ansprechpartner || info.email || info.telefon || info.adresse || info.website || info.logo
  );
}

export function isPartnerInfoEmpty(info: PartnerInfo): boolean {
  return !info.kundennummer && !hasPartnerContact(info);
}

/**
 * The iframe URL carries only the identity key `kundennummer` (plus `context-token`, read separately).
 * Everything else — name, contact, address, website, logo — is fetched from JOKA's own APIs through
 * our backend, so an embedder can no longer put arbitrary branding into the URL.
 */
export function readPartnerIdentity(params: URLSearchParams): PartnerInfo {
  const kundennummer = params.get('kundennummer')?.trim();
  return kundennummer ? { kundennummer } : {};
}

/**
 * Fields a dealer must have in the JOKA shop for the integration to work at all: without `name` the PDF
 * has no branding, without `email` a customer request has nowhere to go. The rest is optional — on live
 * records `logo` and `website` are frequently empty, so requiring them would break nearly every dealer.
 */
export const REQUIRED_PARTNER_FIELDS: (keyof PartnerInfo)[] = ['name', 'email'];

export function missingRequiredPartnerFields(info: PartnerInfo): (keyof PartnerInfo)[] {
  return REQUIRED_PARTNER_FIELDS.filter(field => !info[field]?.trim());
}
